import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from '@thd-olt-component-react/alert';
import { useStore } from '@thd-nucleus/experience-context';
import { CheckNearByStore } from './CheckNearbyStore';
import {
  getSellableQuantityYourStore,
  productShape,
  isShowBuyInStoreNearBy
} from '../../helpers/pod-fulfillment-utils';

export const BopisOffMessage = ({ product }) => {
  const { storeName } = useStore();

  if (!(product && storeName)) {
    return null;
  }

  const sellableQuantity = getSellableQuantityYourStore(product);
  const formattedQty = sellableQuantity > 999 ? '999+' : sellableQuantity;
  return (
    <div>
      {sellableQuantity > 0 && (
        <>
          <Alert type="success" message="Buy in store" inline />
          <div className="store__new-line">
            {formattedQty}<span className="store__alert--black"> in stock at</span> {storeName}
          </div>
        </>
      )}
      {sellableQuantity === 0 && (
        <>
          <Alert type="warning" message="Visit your store to check availability" inline />
        </>
      )}
      {isShowBuyInStoreNearBy(product) && (
        <div className="store__new-line">
          <CheckNearByStore
            product={product}
          />
        </div>
      )}
    </div>
  );
};

BopisOffMessage.propTypes = {
  product: PropTypes.shape({ productShape }).isRequired
};
